import { injectReducer } from '../../store/reducers'
import { injectSaga } from '../../store/sagas'

export default store => {
  const AuthenticatedLayout = require('./containers').default

  const MeetingRoomBookingReducer = require('../../routes/MeetingRoomBookingOverview/modules/reducer')
    .default
  const MeetingRoomBookingSaga = require('../../routes/MeetingRoomBookingOverview/modules/saga')
    .default

  injectReducer(store, {
    key: 'meetingRoomBooking',
    reducer: MeetingRoomBookingReducer
  })
  injectSaga(store, {
    key: 'meetingRoomBooking',
    saga: MeetingRoomBookingSaga
  })

  const profileReducer = require('../../routes/UserProfile/modules/reducer')
    .default
  const profileSaga = require('../../routes/UserProfile/modules/saga').default

  injectReducer(store, { key: 'profile', reducer: profileReducer })
  injectSaga(store, { key: 'profile', saga: profileSaga })

  return AuthenticatedLayout
}



// WEBPACK FOOTER //
// ./src/layouts/Authenticated/index.js